import { index, configure } from 'instantsearch.js/es/widgets';
import { connectHits } from 'instantsearch.js/es/connectors';
import BaseComponent from 'scripts/BaseComponent.js';
import GlobalAutocompleteSearchInstance from '../autocomplete-search';

export default class AutocompleteSearchBlogPageHits extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.name = 'AutocompleteSearchBlogPageHits';

    this.refs = {
      container: '.js-searchBlogPageHits',
    };

    this.dom = {
      $component: component,
      $container: this.$get(this.refs.container),
    };

    this.state = {
      blogResults: [],
      pageResults: [],
      isEmptyClass: 'is-empty',
    };

    this.mount();
  }

  mount() {
    super.mount();

    this.addBlogPageHits();
  }

  addBlogPageHits() {
    const { state } = this;

    const articleCustomHits = connectHits(({ hits }) => {
      state.blogResults = hits;
    });

    const pageCustomHits = connectHits(({ hits }) => {
      state.pageResults = hits;
    });

    GlobalAutocompleteSearchInstance.search.addWidgets([
      index({
        indexName: 'shopify_articles',
      })
        .addWidgets([
          configure({
            hitsPerPage: 4,
          }),
          articleCustomHits(),
        ]),
      index({
        indexName: 'shopify_pages',
      })
        .addWidgets([
          configure({
            hitsPerPage: 4,
          }),
          pageCustomHits(),
        ]),
    ]);

    GlobalAutocompleteSearchInstance.search.on('render', this.renderResults.bind(this));
  }

  renderResults() {
    const { dom } = this;
    const results = this.getCombinedResults();
    const articles = results.filter((result) => !!result.blog);
    const pages = results.filter((result) => !result.blog);

    this.setEmptyStats(results.length);
    dom.$container.innerHTML = '';
    articles.forEach(this.renderArticleResult.bind(this));
    pages.forEach(this.renderPageResult.bind(this));
  }

  getCombinedResults() {
    const { state: { blogResults, pageResults } } = this;
    const results = [];

    for (let i = 0; i < 2; i += 1) {
      const article = blogResults[i];
      if (article) results.push(article);
    }

    for (let i = 0; i < 2; i += 1) {
      const page = pageResults[i];
      if (page) results.push(page);
    }

    for (let i = 2; i < 4; i += 1) {
      const article = blogResults[i];
      if (article) results.push(article);
    }

    for (let i = 2; i < 4; i += 1) {
      const page = pageResults[i];
      if (page) results.push(page);
    }

    return results.slice(0, 4);
  }

  setEmptyStats(count) {
    const { dom, state } = this;

    if (count === 0) {
      dom.$component.classList.add(state.isEmptyClass);
    } else {
      dom.$component.classList.remove(state.isEmptyClass);
    }
  }

  renderArticleResult(hit) {
    const { dom } = this;

    const li = document.createElement('li');
    li.className = `${this.name}__item`;

    li.innerHTML = `
      <article class="${this.name}__article">
        <a
          class="${this.name}__link body"
          href="/blogs/${hit.blog.handle}/${hit.handle}"
        >
          ${hit.title}
        </a>
      </article>
    `;

    dom.$container.appendChild(li);
  }

  renderPageResult(hit) {
    const { dom } = this;

    const li = document.createElement('li');
    li.className = `${this.name}__item`;

    li.innerHTML = `
      <article class="${this.name}__page">
        <a
          class="${this.name}__link body"
          href="/pages/${hit.handle}"
        >
          ${hit.title}
        </a>
      </article>
    `;

    dom.$container.appendChild(li);
  }
}
